<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="scheduleActivity"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Schedule Activity</b>
              </span>
            </nav>
            <br />
            <div v-if="failure">
              <p align="center" class="alert-danger">{{ failureMessage }}</p>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-6">
                <div class="row">
                  <div
                    class="col-12 col-lg-4 col-md-12 col-sm-12 d-md-flex justify-content-lg-end align-items-center"
                  >
                    <label
                      name="Employee"
                      class="col-form-label col-form-label-sm required"
                    >Employee</label>
                  </div>
                  <div
                    class="col-12 col-lg-6 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 ml-lg-0 mb-md-3 mb-sm-3s"
                  >
                    <select
                      v-if="this.disableemployeedd"
                      name="Employee"
                      data-vv-name="Employee"
                      v-validate="'required'"
                      v-model.trim="activity.empId"
                      class="form-control input-sm"
                      disabled
                    >
                      <option
                        selected
                        v-for="emp in employees"
                        v-bind:value="emp.employeeId"
                        v-bind:key="emp.employeeId"
                      >{{ emp.firstName }} , {{ emp.lastName }}</option>
                    </select>
                    <select
                      v-else
                      v-validate="'required'"
                      name="Employee"
                      data-vv-name="Employee"
                      v-model.trim="activity.empId"
                      class="form-control input-sm"
                    >
                      <!-- Admin and BO-->
                      <option disabled value>Select Employee</option>
                      <option
                        selected
                        v-for="emp in employees"
                        v-bind:value="emp.employeeId"
                        v-bind:key="emp.employeeId"
                      >{{ emp.firstName }} , {{ emp.lastName }}</option>
                    </select>
                    <div
                      v-if="errors.has('Employee')"
                      class="alert-danger"
                    >{{ errors.first("Employee") }}</div>
                  </div>
                  <br />
                  <br />
                  <div
                    class="col-12 col-lg-4 col-md-12 col-sm-12 d-md-flex justify-content-lg-end align-items-center"
                  >
                    <label name="Date From" class="col-form-label col-form-label-sm required">Date</label>
                  </div>
                  <div
                    class="col-12 col-lg-6 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 ml-lg-0 mb-md-3 mb-sm-3s"
                  >
                    <input
                      type="Date"
                      v-validate="'required'"
                      name="scheduleD"
                      data-vv-name="Schedule Date"
                      v-model.trim="activity.scheduleDate"
                      class="form-control input-sm"
                    />
                    <div
                      v-if="errors.has('Schedule Date')"
                      class="alert-danger"
                    >The Date field is required</div>
                  </div>
                  <br />
                  <br />
                  <div
                    class="col-12 col-lg-4 col-md-12 ml-md-2 ml-sm-0 ml-lg-0 col-sm-12 d-md-flex justify-content-lg-end align-items-center"
                  >
                    <label name="Notes" class="col-form-label col-form-label-sm required">Notes</label>
                  </div>
                  <div
                    class="col-12 col-lg-6 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 ml-lg-0 mb-md-3 mb-sm-3s"
                  >
                    <textarea
                      v-model.trim="activity.notes"
                      v-validate="'required'"
                      name="Notes"
                      data-vv-name="Notes"
                      spellcheck="true"
                      placeholder="Enter message here"
                      rows="10"
                      cols="5"
                      class="form-control input-sm"
                      :maxlength="150"
                    />
                    <div v-if="errors.has('Notes')" class="alert-danger">{{ errors.first("Notes") }}</div>
                  </div>
                </div>
                <br />
                <div
                  class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
                >
                  <div class="col-12 col-lg-4 justify-content-end align-items-center mb-4">
                    <button
                      class="btn btn-secondary ml-3"
                      type="submit"
                      @click="scheduleActivity"
                    >Add Schedule</button>
                  </div>
                  <!--col end-->
                </div>
                <!--row end-->
              </div>
              <!-- <div class="vertical-line"></div> -->
              <div class="col-12 col-lg-6 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-12">
                    <span>
                      <b>Display Scheduled Activities</b>
                    </span>
                  </div>
                </div>
                <br />
                <div class="row mt-2 justify-content-center">
                  <div class="col">
                    <div class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer">
                      <v-table
                        id="myemployeelistTable"
                        :data="schActForDisplay"
                        class="table table-sm table-bordered table-striped"
                      >
                        <thead class="table-month-header-blue wrap-text" slot="head">
                          <v-th sortKey="creationD">Create Date</v-th>
                          <v-th sortKey="scheduleD">Schedule Date</v-th>
                          <v-th sortKey="employee.firstName">Name</v-th>
                          <v-th sortKey="scheduleNotes">Last Updated Notes</v-th>
                          <v-th sortKey="scheduleId">Action</v-th>
                        </thead>
                        <tbody slot="body" slot-scope="{ displayData }">
                          <tr v-for="(activity, dindex) in displayData" :key="dindex">
                            <td>{{ activity.creationD | moment("MM/DD/YYYY") }}</td>
                            <td>{{ activity.scheduleD | moment("MM/DD/YYYY") }}</td>
                            <td>
                              {{ activity.employee.firstName }} ,
                              {{ activity.employee.lastName }}
                            </td>
                            <td>{{ activity.scheduleNotes }}</td>
                            <td>
                              <button
                                class="btn btn-secondary ml-3 btn-sm"
                                type="submit"
                                @click="deleteActivity(activity.scheduleId)"
                              >Delete</button>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
        </div>
        <!-- Container DIV Tag end-->
        <!-- End of the code for this screen here -->

        <!-- Page Container DIV Tag end-->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import activityTraking from '../js/http-activitytracking'
import manageemployeeSvc from '../js/http-employee.js'
import { stringify } from 'querystring'
import moment from 'moment'
import util from '../js/common-utils'

export default {
  components: { MainMenu, TopHeader, BottomFooter },
  name: 'scheduleActivity',
  data () {
    return {
      activity: this.initializedata(), // intialize  entry fields
      employees: [], // get employees
      disableemployeedd: false,
      norecordsfound: false,
      saved: false,
      failure: false,
      failureMessage: "We're unable to schedule Activity information",
      colheaders: [
        { header: 'Create Date' },
        { header: 'Schedule Date' },
        { header: 'Name' },
        { header: 'Last Updated Notes' },
        { header: 'Action' }
      ],
      schActForDisplay: []
    }
  },
  methods: {
    initializedata () {
      return {
        activityId: '',
        empId:
          this.$session.get('user_role') == 'SR'
            ? this.$session.get('employee_id')
            : '',
        scheduleDate: moment().format('YYYY-MM-DD'),
        notes: '',
        createdDate: '',
        createdUserId: ''
      }
    },
    scheduleActivity () {
      this.norecordsfound = false
      this.failure = false
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          // Check if the date is valid
          // var schD = moment(this.scheduleDate);
          var today = moment().format('YYYY-MM-DD')
          console.log(this.activity.scheduleDate)
          console.log(util.strToDate(this.activity.scheduleDate))
          // console.log("IS SAME or AFTER: " + moment(this.activity.scheduleDate).isSameOrAfter(today));
          if (moment(this.activity.scheduleDate).isSameOrAfter(today)) {
            let schactivityPayload = {
              employeeId: this.activity.empId,
              scheduleD: util.strToDate(this.activity.scheduleDate),
              scheduleNotes: this.activity.notes,
              creationUserI: this.$session.get('user_id')
            }
            activityTraking
              .post('/schedule/', schactivityPayload)
              .then(response => {
                var savedActivity = response.data
                // if(status=="CREATED"){
                if (savedActivity != null && savedActivity.scheduleId != 0) {
                  this.errors.clear()
                  this.$validator.reset()
                  this.activity = this.initializedata()
                  // get the activity info from system
                  activityTraking
                    .get('/schedule/' + savedActivity.scheduleId)
                    .then(Response => {
                      // console.log("Schedule returned:"+ JSON.stringify(Response.data))
                      // update the table below
                      this.schActForDisplay.unshift(Response.data)
                    })
                }
                // else if (status=="BAD_REQUEST"){
                // this.failure = true;
                // }
                else {
                  console.log('Failed to save Activity!!')
                  this.failure = true
                }
                // TODO= Handle following scenarios - 500 or any other Status Codes
              })
              .catch(e => {
                console.log('Failed: ' + e)
                this.failure = true
              })
          } else {
            const field = this.$validator.fields.find({
              name: 'Schedule Date'
            })
            this.$validator.flag('Schedule Date', {
              valid: false,
              invalid: true
            })
            this.$validator.errors.add({
              id: field.id,
              field: 'Schedule Date',
              msg: 'Schedule Date cannot be past'
            })
          } // else case
        } // end if
      })
    },
    deleteActivity (actId) {
      activityTraking.delete('/schedule/' + actId).then(Response => {
        var status = Response.data
        // console.log("Deleted resonse" +status)
        if (status == 'OK') {
          // TODO - Find a way to remove element from array with specific ID OR make Retreive Call to get Fresh Data
          this.retrieveScheduledActivities()
          this.norecordsfound = false
        } else {
          // message that failed to delete?
          console.log('Error deleting activity')
        }
      })
    },
    retrieveScheduledActivities () {
      this.norecordsfound = false
      // Check if logged in employee is SR
      if (this.$session.get('user_role') == 'SR') {
        activityTraking
          .get('schedule/employee/' + this.$session.get('employee_id'))
          .then(response => {
            // console.log("Search Results:"+ JSON.stringify(response.data))
            if (response.data.length != 0) {
              this.norecordsfound = false
              this.schActForDisplay = response.data
            } else {
              this.norecordsfound = true
              this.schActForDisplay = []
            }
          })
          .catch(e => {
            console.log('Failed to get Schedule activities for Sales Rep')
            this.norecordsfound = true
            this.schActForDisplay = []
          })
      } else {
        activityTraking
          .get('/schedule/')
          .then(response => {
            // console.log("Search Results:"+ JSON.stringify(response.data))
            this.schActForDisplay = response.data
            if (this.schActForDisplay.length != 0) {
              this.norecordsfound = false
            } else {
              this.norecordsfound = true
              this.schActForDisplay = []
            }
          })
          .catch(e => {
            console.log('Failed to get Schedule activities for employees')
            this.schActForDisplay = []
            this.norecordsfound = true
          })
      } // end else
    },
    fetchData () {
      // get all employees
      // Check if the logged in used is sales rep
      if (this.$session.get('user_role') == 'SR') {
        this.employees = [
          {
            employeeId: this.$session.get('employee_id'),
            firstName: this.$session.get('first_name'),
            lastName: this.$session.get('last_name')
          }
        ]
        this.activity.empId = this.$session.get('employee_id')
        // disable the Dropdown
        this.disableemployeedd = true
      } else {
        this.disableemployeedd = false
        // create objet
        let searchEmployee = {
          firstName: '',
          lastName: '',
          roleType: '', // All Employees
          statusCode: ''
        }
        manageemployeeSvc
          .post('/employee/search/', searchEmployee)
          .then(response => {
            this.employees = response.data
          })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }
      // get activities
      this.retrieveScheduledActivities()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#scheduleActivity').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
.row {
  display: flex;
}
.column1 {
  flex: 40%;
  padding: 10px;
}
.column2 {
  flex: 60%;
  padding: 10px;
}
.sidebyside {
  float: left;
}
.wrap-text {
  white-space: nowrap;
}
</style>
